import React from 'react'
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import GridBlock from "components/GridBlock";
import Typography from "@material-ui/core/Typography";
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";

const useStyle = makeStyles(theme => ({
    root: {},
    subject: {
        flexGrow: 1
    },
    unreadElements: {
        marginLeft: theme.spacing(2)
    }
}))

function GeneralInfoExpansionPanelTitle(
    {
        subject,
        unreadElements,
        expanded,
        toggleThread,
    }) {
    const classes = useStyle();

    const toggleThread2 = () => {
        toggleThread(!expanded);
    }
    return (
        <GridBlock
            alignItems="center"
            wrap='nowrap'
            justify='space-between'
        >
            <Typography
                className={classes.subject}
                variant='h6'
                onClick={toggleThread2}
            >
                {subject}
                {!!unreadElements &&
                    <ErrorOutlineOutlinedIcon color='error' className={classes.unreadElements} />
                }
            </Typography>

            <WorkableIconExpandButton
                color='primary'
                onClick={toggleThread2}
                expanded={expanded}
            />
        </GridBlock>
    )
}

GeneralInfoExpansionPanelTitle.propTypes = {
    subject: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    toggleThread: PropTypes.func.isRequired
}

export default GeneralInfoExpansionPanelTitle;